import { render, staticRenderFns } from "./TreeCanopyCoverTcc.vue?vue&type=template&id=6b6e7cab&lang=pug"
import script from "./TreeCanopyCoverTcc.vue?vue&type=script&lang=js"
export * from "./TreeCanopyCoverTcc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports